import {PayrollCompensationItemModel, PayrollEmployeeBaseCompModel, PayrollEmployeeBonusModel, PayrollEmployeeCompItemModel, PayrollEmployeeModel, PayrollEmployeeOvertimeModel, PayrollEmployeeRaiseModel, PayrollPositionModel} from "../../__generated__/generated_types";

export type CompItem = Pick<PayrollEmployeeCompItemModel, 'id' | 'calculationType' | 'costPerPayPeriod' | 'effectiveStartDate' | 'annualCostCap'>
& { compensationItem: (
  { __typename?: 'PayrollCompensationItemModel' }
  & Pick<PayrollCompensationItemModel, 'id' | 'clientId' | 'type'>)};

export type PayrollEmployeeDataRow = {
    empNum: number | undefined;
    empRowNum: number;
    employeeId: string;
    employee: Pick<PayrollEmployeeModel, 'id' | 'externalSystemEmployeeId' | 'firstName' | 'lastName' | 'type' | 'classification' | 'startDate' | 'terminationDate'> | undefined;
    position: Pick<PayrollPositionModel, 'id' | 'name'> | undefined;
    propertyAttribution: {
        attributionPercentage: string | null | undefined;
        property: {
            id: string;
            name: string;
        };
    } | undefined;
    baseComp: Pick<PayrollEmployeeBaseCompModel, 'expectedHoursPerWeek' | 'hourlyCompensation' | 'annualCompensation' | 'compensationType'> | null | undefined;
    overtime?: Pick<PayrollEmployeeOvertimeModel, 'id' | 'hourlyCompensation' | 'expectedHoursPerWeek' | 'effectiveStartDate' | 'effectiveEndDate'>;
    bonus?: Pick<PayrollEmployeeBonusModel, 'id' | 'bonusType' | 'frequency' | 'amount' | 'bonusMonth' | 'bonusDay' | 'onetimeBonusDate' | 'effectiveStartDate'>;
    raise?: Pick<PayrollEmployeeRaiseModel, 'id' | 'raiseType' | 'frequency' | 'amount' | 'raiseMonth' | 'raiseDay' | 'onetimeRaiseDate' | 'effectiveStartDate'>;
    medical: CompItem | undefined;
    dental: CompItem | undefined;
    vision: CompItem | undefined;
    r401k: CompItem | undefined;
    medicare: CompItem | undefined;
    socialSecurity: CompItem | undefined;
    futa: CompItem | undefined;
    suta: CompItem | undefined;
    wc: CompItem | undefined;
    propertyLocked: boolean;
};

export type TaxFilterOptions = {
    r401k: {value: string | "empty" | "any", label: string}[];
    medicare: {value: string | "empty" | "any", label: string}[];
    socialSecurity: {value: string | "empty" | "any", label: string}[];
    futa: {value: string | "empty" | "any", label: string}[];
    suta: {value: string | "empty" | "any", label: string}[];
    wc: {value: string | "empty" | "any", label: string}[];
}

export type TaxFilterElementType = string | "empty" | undefined;

export type TaxFilter = {
    r401k: TaxFilterElementType;
    medicare: TaxFilterElementType;
    socialSecurity: TaxFilterElementType;
    futa: TaxFilterElementType;
    suta: TaxFilterElementType;
    wc: TaxFilterElementType;
}

export const DEFAULT_TAX_FILTER: TaxFilter = {
    r401k: undefined,
    medicare: undefined,
    socialSecurity: undefined,
    futa: undefined,
    suta: undefined,
    wc: undefined
};